import { namespace, OfcsObject } from '../../../../../FrontendBundle/Resources/js/ofcs';
import PropertiesPanel from '../propertiesPanel';
import AccessoryField from './accessoryField';
import AlignField from './alignField';
import AngleField from './angleField';
import CenterLeftField from './centerLeftField';
import CenterTopField from './centerTopField';
import ConnectorOffsetField from './connectorOffsetField';
import ConnectorWidthField from './connectorWidthField';
import CoverField from './coverField';
import CutangleLeftField from './cutangleLeftField';
import CutangleTopField from './cutangleTopField';
import DepthDropdownField from './depthDropdownField';
import DepthField from './depthField';
import DrillSizeField from './drillSizeField';
import FontSizeField from './fontSizeField';
import HeightField from './heightField';
import LeftField from './leftField';
import RotationField from './rotationField';
import RotationSelectField from './rotationSelectField';
import SealingField from './sealingField';
import SizeField from './sizeField';
import TablelegSizeField from './tablelegSizeField';
import TopField from './topField';
import VersionField from './versionField';
import WidthField from './widthField';

/**
 * @class FieldFactory
 */
class FieldFactory extends OfcsObject {
    /**
     * @param {Object} translations
     * @param {MeasurementsConverter} converter
     * @param {LengthUnit} lengthUnit
     * @param {CommandExecutor} commandExecutor - Global command executor
     */
    constructor(translations, converter, lengthUnit, commandExecutor) {
        super();
        this.translations = translations || {};
        this.converter = converter;
        this.lengthUnit = lengthUnit;
        this.commandExecutor = commandExecutor;
    }

    /**
     * Create a field object by type.
     *
     * @param {string} type
     * @param {jQuery} control
     *
     * @return {AbstractField}
     */
    create(type, control) {
        switch (type) {
            case PropertiesPanel.FIELD_TOP:
                return new TopField(
                    control,
                    this.translations,
                    this.converter,
                    this.lengthUnit,
                    this.commandExecutor,
                );

            case PropertiesPanel.FIELD_CENTER_TOP:
                return new CenterTopField(
                    control,
                    this.translations,
                    this.converter,
                    this.lengthUnit,
                    this.commandExecutor,
                );

            case PropertiesPanel.FIELD_CUTANGLE_TOP:
                return new CutangleTopField(
                    control,
                    this.translations,
                    this.converter,
                    this.lengthUnit,
                    this.commandExecutor,
                );

            case PropertiesPanel.FIELD_LEFT:
                return new LeftField(
                    control,
                    this.translations,
                    this.converter,
                    this.lengthUnit,
                    this.commandExecutor,
                );

            case PropertiesPanel.FIELD_CONNECTOR_OFFSET:
                return new ConnectorOffsetField(
                    control,
                    this.translations,
                    this.converter,
                    this.lengthUnit,
                    this.commandExecutor,
                );

            case PropertiesPanel.FIELD_CENTER_LEFT:
                return new CenterLeftField(
                    control,
                    this.translations,
                    this.converter,
                    this.lengthUnit,
                    this.commandExecutor,
                );

            case PropertiesPanel.FIELD_CUTANGLE_LEFT:
                return new CutangleLeftField(
                    control,
                    this.translations,
                    this.converter,
                    this.lengthUnit,
                    this.commandExecutor,
                );

            case PropertiesPanel.FIELD_WIDTH:
                return new WidthField(
                    control,
                    this.translations,
                    this.converter,
                    this.lengthUnit,
                    this.commandExecutor,
                );

            case PropertiesPanel.FIELD_CONNECTOR_WIDTH:
                return new ConnectorWidthField(
                    control,
                    this.translations,
                    this.converter,
                    this.lengthUnit,
                    this.commandExecutor,
                );

            case PropertiesPanel.FIELD_HEIGHT:
                return new HeightField(
                    control,
                    this.translations,
                    this.converter,
                    this.lengthUnit,
                    this.commandExecutor,
                );

            case PropertiesPanel.FIELD_ROTATION:
                return new RotationField(control, this.translations);

            case PropertiesPanel.FIELD_ROTATION_SELECT:
                return new RotationSelectField(control, this.translations);

            case PropertiesPanel.FIELD_DEPTH:
                return new DepthField(
                    control,
                    this.translations,
                    this.converter,
                    this.lengthUnit,
                    this.commandExecutor,
                );

            case PropertiesPanel.FIELD_DEPTHDROPDOWN:
                return new DepthDropdownField(control, this.translations);

            case PropertiesPanel.FIELD_ALIGN:
                return new AlignField(control, this.translations);

            case PropertiesPanel.FIELD_ACCESSORY:
                return new AccessoryField(control, this.translations);

            case PropertiesPanel.FIELD_SIZE:
                return new SizeField(control, this.translations);

            case PropertiesPanel.FIELD_VERSION:
                return new VersionField(control, this.translations);

            case PropertiesPanel.FIELD_FONT_SIZE:
                return new FontSizeField(control, this.translations);

            case PropertiesPanel.FIELD_COVER:
                return new CoverField(control, this.translations);

            case PropertiesPanel.FIELD_SEALING:
                return new SealingField(control, this.translations);

            case PropertiesPanel.FIELD_DRILL_SIZE:
                return new DrillSizeField(control, this.translations);

            case PropertiesPanel.FIELD_TABLELEG_SIZE:
                return new TablelegSizeField(control, this.translations);

            case PropertiesPanel.FIELD_ANGLE:
                return new AngleField(control, this.translations);

            default:
                throw new Error(`Unknown field: ${type}`);
        }
    }
}

namespace('Ofcs.Editor.PropertiesPanel');
Ofcs.Editor.PropertiesPanel.FieldFactory = FieldFactory;
export default FieldFactory;
